import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map, catchError } from 'rxjs/operators';

import { Link } from '@frontend/core';
import { Observable, of, throwError } from 'rxjs';

interface linksResponse {
  'data': Link[]
}
export interface DynamicLinkRequest {
    class: string, // 'lesson' or 'course' or 'tip'
    slug: string, // "sint-illum-consectetur-rerum-hic-velit-omnis-assumenda3336",
    topic: string, // "cultureconnector" or "icpendulum",
    site: string, // "culturettt", NOTE!!!!!!! put 'demo' here if you want a demo placeholder response
    subdomain: string, // slug of a brand
}

@Injectable({
  providedIn: 'root'
})
export class LinksService {

  linksByModel : any;
  userLinks : Link[];
  callToActionTypes : {cta_label: string, types : string[]}[];

  constructor(
    private http: HttpClient,
    ) {
    this.linksByModel = {};
    this.callToActionTypes = [
      {cta_label: 'get', types : ['resource','book']},
      {cta_label: 'view', types : ['publication','news','channel','journal','blog','profile','person']},
      {cta_label: 'connect', types : ['community','connect']},
      {cta_label: 'play', types : ['player']},
      {cta_label: 'listen', types : ['podcast']},
      {cta_label: 'watch', types : ['video']},
      {cta_label: 'start', types : ['course']},
      {cta_label: 'visit', types : ['organisation']},
    ];
   }


   getPlaceholder (){ // make a dummy link
    let link : Link = {
      id:244,
      name:"A podcast about virtual teams",
      label:"21st Century Work Life",
      url:"https:\/\/www.virtualnotdistant.com\/podcasts",
      description:"A podcast about virtual teams and other aspects of working life. Hosted by Pilar Orti.",
      cta_label:"Listen",
      cta_type:"podcast",
      category:"shownotes",
      type:"resources",
      image:{
        id:156,
        disk:"cloudinary",
        path:"v1671029175/resources/podcastlogo_yagluo.png",
        alt_text:"Podcast logo: 21st Century Work Life",
        caption:"Podcast logo: 21st Century Work Life",
        credits:"Pilar Orti",
        licence:null,
        role:"thumbnail",
      },
      icon:{identifier_1:'fa-podcast',identifier_2:null}};
    return link;
   }

    transformLink (link){
      // The backend sends a flat `images` array; pick the link's cover image (disk-agnostic).
      if (link?.images?.length){
        debugger;
        link.image = link.images.find(i=>i.role==='thumbnail') ?? link.images[0];
      }
      return link;
    };
    transformLinks (links){
      if (links?.length){
        links.forEach(link => {
          link = this.transformLink(link);
        });
      };
      return links;
    }

   cacheLinksDataByModel (modelNameSingular,identifier, data){
    let cachedIdentifier = !Number(identifier) ? identifier.replaceAll('-','') : identifier;    if (!this.linksByModel[modelNameSingular]){
      this.linksByModel[modelNameSingular] = {};
    };
    if (!this.linksByModel[modelNameSingular][cachedIdentifier]){
      this.linksByModel[modelNameSingular][cachedIdentifier] = {};
    };
      this.linksByModel[modelNameSingular][cachedIdentifier] = data;
    }

    getLinks (modelNameSingular,identifier) : Observable<Link[]> {
      let cachedIdentifier = !Number(identifier) ? identifier.replaceAll('-','') : identifier;
      if (this.linksByModel[modelNameSingular] && this.linksByModel[modelNameSingular][cachedIdentifier]){
        return of(this.linksByModel[modelNameSingular][cachedIdentifier]);
      };
      return this.http.get<linksResponse>(
        'api/v1/links/'+modelNameSingular+'/'+identifier)
          .pipe(
            map(response =>{
              if (response && response.data ){
                response.data = this.transformLinks(response.data);
                this.cacheLinksDataByModel(modelNameSingular,identifier,response.data);
                return response.data;
              };
              return [];
            })
          )
    };

    getUserLinks (){
      if (this.userLinks){
        return of(this.userLinks);
      };
      let filters="profile,social";
      return this.http.get<linksResponse>(
        'api/v1/user-links/filtered?categories='+filters)
          .pipe(
            map(response =>{
              if (response && response.data ){
                response.data = this.transformLinks(response.data);
                this.userLinks = response.data;
                return response.data;
              };
            })
          )
    };
    getDynamicLinks (links: DynamicLinkRequest[]){
      return this.http.post<linksResponse>(
        'api/v1/links/dynamic',{links:links})
          .pipe(
            map(response =>{
              if (response && response.data ){
                response.data = this.transformLinks(response.data);
                // no caching?
                return response.data;
              };
            })
          )
    };
    updateUserProfileLink (link : Link){
      return this.http.patch<{'data':Link,'message':string,'link_id':number}>(
        'api/v1/user-links/update/'+link.id,link)
          .pipe(
            catchError((error)=>{
              console.log('an error occurred: '+error);
              return throwError('a problem updating links');
            }),
            map(response =>{
              if (!response || !this.userLinks?.length){
                throw 'a problem updating links';
              };
              if (response.data){
                response.data = this.transformLink(response.data);
                let updatedLinkIndex = this.userLinks.findIndex(l=>l.id == response.data.id);
                this.userLinks[updatedLinkIndex] = response.data;
              } else if (response.message && response.message == 'link_deleted'){
                this.userLinks = this.userLinks.filter(l=>l.id !== link.id);
              };
              return this.userLinks;
            })
          )
    };
    createUserProfileLink (link : Link){
      return this.http.post<{'data':Link}>(
        'api/v1/user-links',link)
          .pipe(
            catchError((error)=>{
              console.log('an error occurred: '+error);
              return throwError('a problem creating links');
            }),
            map(response =>{
              if (response && response.data ){
                response.data = this.transformLink(response.data);
                if (!this.userLinks){
                  this.userLinks = [];
                };
                this.userLinks.push(response.data);
                return this.userLinks;
              };
            })
          )
    };

}
